export default __webpack_public_path__ + "static/media/rep.ff40cdf9.svg";